import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import OpenOrderTable from './OpenOrderTable';
import OverlayForm from './OverlayForm';

const DashboardContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0;
  background-color: #f5f5f5;
  filter: ${props => props.isBlurred ? 'blur(5px)' : 'none'};
  transition: filter 0.3s ease;
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: #fff;
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

const Dashboard = () => {
  const [showForm, setShowForm] = useState(true);

  useEffect(() => {
    // Check if form was completed in this session
    const formData = localStorage.getItem('userFormData');
    const formCompleted = sessionStorage.getItem('formCompleted');
    
    if (formData && formCompleted) {
      setShowForm(false);
    }
  }, []);

  const handleFormComplete = () => {
    // Set both form completion flags
    sessionStorage.setItem('formCompleted', 'true');
    setShowForm(false);
  };

  return (
    <>
      <DashboardContainer isBlurred={showForm}>
        <MainContent>
          <OpenOrderTable />
        </MainContent>
      </DashboardContainer>
      {showForm && <OverlayForm onComplete={handleFormComplete} />}
    </>
  );
};

export default Dashboard; 